import { BsBuilding, BsClipboard2Check, BsCardChecklist } from "react-icons/bs";

import { Circle, GitBranch, Send } from "react-feather";

export default [
	{
		header: "Бусад",
	},
	{
		id: "dormitory",
		title: "Дотуур байр",
		icon: <BsBuilding size={20} />,
		navLink: "/other/boardinghouse",
	},
	// {
	// 	id: "order",
	// 	title: "Захиалга",
	// 	icon: <BsClipboard2Check size={20} />,
	// 	children: [
	// 		{
	// 			id: "sport",
	// 			title: "Спорт заал",
	// 			icon: <Circle size={12} />,
	// 			navLink: "/order/sport-hall",
	// 		},
	// 		{
	// 			id: "gym",
	// 			title: "Бялдаржуулах төв",
	// 			icon: <Circle size={12} />,
	// 			navLink: "/order/fitness",
	// 		},
	// 		// {
	// 		// 	id: "hospital",
	// 		// 	title: "Эмнэлэг",
	// 		// 	icon: <Circle size={12} />,
	// 		// 	navLink: "/cards/advance",
	// 		// },
	// 		// {
	// 		// 	id: "library",
	// 		// 	title: "Номын сан",
	// 		// 	icon: <Circle size={12} />,
	// 		// 	navLink: "/cards/analytics",
	// 		// },
	// 	],
	// },
];
